import React from 'react';
import __ from 'lodash';

class DdMapel extends React.Component{
    render(){
        return (
            this.props.mapel.map((val) =>
                <option key={val.id_mapel} value={val.id_mapel}>{val.nama_mapel}</option>
            )            
        )
    }
}

export default DdMapel;